"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAudioVideoDevice = void 0;
var _react = require("react");
var _audioVideoHelpers = require("../audioVideo/audioVideoHelpers");
var _DeviceTypes = require("@studio/constants/DeviceTypes");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Fetches devices of a specific type and updates state
 *
 * @param {Object} meetingSession    - The Chime meeting session
 * @param {Function} setDevices      - State setter for the devices list
 * @param {Function} onDeviceChanged - Callback when device is selected/changed
 * @param {string} selectedDeviceId  - Currently selected device ID
 * @param {string} deviceType        - Type of device to fetch ('audioInput', 'audioOutput', or 'videoInput')
 * @param {Object} transformedVideoInput - Transformed video input object (for video devices)
 * @returns {Promise<void>}          - A promise that resolves when the audio/video devices are set.
 */
var fetchDevices = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var meetingSession, setDevices, onDeviceChanged, selectedDeviceId, deviceType, transformedVideoInput, devices, firstDeviceId, resolvedDevice, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          meetingSession = _ref.meetingSession, setDevices = _ref.setDevices, onDeviceChanged = _ref.onDeviceChanged, selectedDeviceId = _ref.selectedDeviceId, deviceType = _ref.deviceType, transformedVideoInput = _ref.transformedVideoInput;
          if (meetingSession) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          devices = []; // Fetch the appropriate device list based on the device type
          _t = deviceType;
          _context.n = _t === _DeviceTypes.AUDIO_INPUT ? 2 : _t === _DeviceTypes.AUDIO_OUTPUT ? 4 : _t === _DeviceTypes.VIDEO_INPUT ? 6 : 8;
          break;
        case 2:
          _context.n = 3;
          return (0, _audioVideoHelpers.listAudioInputDevices)(meetingSession);
        case 3:
          devices = _context.v;
          return _context.a(3, 9);
        case 4:
          _context.n = 5;
          return (0, _audioVideoHelpers.listAudioOutputDevices)(meetingSession);
        case 5:
          devices = _context.v;
          return _context.a(3, 9);
        case 6:
          _context.n = 7;
          return (0, _audioVideoHelpers.listVideoInputDevices)(meetingSession);
        case 7:
          devices = _context.v;
          return _context.a(3, 9);
        case 8:
          console.error("Unknown device type: ".concat(deviceType));
          return _context.a(2);
        case 9:
          // Update the device state
          setDevices(devices);

          // If there are devices and the current selection is either the first device
          // or not set, select the first device by default
          if (devices && devices.length > 0) {
            firstDeviceId = devices[0].deviceId;
            if (selectedDeviceId === firstDeviceId || selectedDeviceId === '') {
              // Use transformedVideoInput if its device matches firstDeviceId, else use firstDeviceId
              resolvedDevice = (transformedVideoInput === null || transformedVideoInput === void 0 ? void 0 : transformedVideoInput.device) === firstDeviceId ? transformedVideoInput : firstDeviceId;
              onDeviceChanged(resolvedDevice);
            }
          }
        case 10:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function fetchDevices(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Creates a device change observer for a specific device type
 *
 * @param {string} deviceType   - Type of device ('audioInput', 'audioOutput', or 'videoInput')
 * @param {Function} setDevices - State setter for the devices list
 * @returns {Object}            - Device change observer object
 */
var createDeviceChangeObserver = function createDeviceChangeObserver(deviceType, setDevices) {
  switch (deviceType) {
    case _DeviceTypes.AUDIO_INPUT:
      return {
        audioInputsChanged: function audioInputsChanged(newDeviceList) {
          setDevices(newDeviceList);
        }
      };
    case _DeviceTypes.AUDIO_OUTPUT:
      return {
        audioOutputsChanged: function audioOutputsChanged(newDeviceList) {
          setDevices(newDeviceList);
        }
      };
    case _DeviceTypes.VIDEO_INPUT:
      return {
        videoInputsChanged: function videoInputsChanged(newDeviceList) {
          setDevices(newDeviceList);
        }
      };
    default:
      console.error("Unknown device type: ".concat(deviceType));
      return {};
  }
};

/**
 * A custom React hook that fetches devices and handles their observers
 *
 * @param {Object} meetingSession    - The Chime meeting session
 * @param {Function} setDevices      - State setter for the devices list
 * @param {Function} onDeviceChanged - Callback when a device is selected/changed
 * @param {string} selectedDeviceId  - Currently selected device ID
 * @param {string} deviceType        - Type of device to fetch ('audioInput', 'audioOutput', or 'videoInput')
 * @param {Object} transformedVideoInput - Transformed video input object (for video devices)
 * @returns {void}
 */
var useAudioVideoDevice = exports.useAudioVideoDevice = function useAudioVideoDevice(_ref3) {
  var meetingSession = _ref3.meetingSession,
    setDevices = _ref3.setDevices,
    onDeviceChanged = _ref3.onDeviceChanged,
    selectedDeviceId = _ref3.selectedDeviceId,
    deviceType = _ref3.deviceType,
    transformedVideoInput = _ref3.transformedVideoInput;
  (0, _react.useEffect)(function () {
    if (!meetingSession) return;

    // Create the appropriate observer for this device type
    var observer = createDeviceChangeObserver(deviceType, setDevices);

    // Register the observer
    (0, _audioVideoHelpers.addDeviceChangeObserver)(meetingSession, observer);

    // Fetch the initial devices
    fetchDevices({
      meetingSession: meetingSession,
      setDevices: setDevices,
      onDeviceChanged: onDeviceChanged,
      selectedDeviceId: selectedDeviceId,
      deviceType: deviceType,
      transformedVideoInput: transformedVideoInput
    });

    // Clean up the observer when the component unmounts
    return function () {
      (0, _audioVideoHelpers.removeDeviceChangeObserver)(meetingSession, observer);
    };
  }, [selectedDeviceId]);
};